import { Routes } from '@angular/router';
import { UserRole } from '@klubovna/api-client';
import { authGuard, ConsoleRoutePath, guestGuard, roleGuard } from '@shared';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    loadComponent: () => import('./modules/auth/login/login.component').then((m) => m.LoginComponent),
    canActivate: [ guestGuard ],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./modules/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: ConsoleRoutePath.ChangePassword,
    canActivate: [ authGuard ],
    loadComponent: () => import('./modules/auth/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
  },
  {
    path: ConsoleRoutePath.MemberUnavailable,
    canActivate: [ authGuard ],
    loadComponent: () => import('./modules/auth/member-unavailable/member-unavailable.component').then((m) => m.MemberUnavailableComponent),
  },
  {
    path: 'admin',
    canActivate: [ authGuard, roleGuard ],
    data: { roles: [ UserRole.Owner, UserRole.Admin, UserRole.EventAdmin ] },
    loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'volunteer',
    canActivate: [ authGuard, roleGuard ],
    data: { roles: [ UserRole.Owner, UserRole.Admin, UserRole.Volunteer ] },
    loadChildren: () => import('./modules/volunteer/volunteer.module').then((m) => m.VolunteerModule),
  },
  {
    path: 'pos',
    canActivate: [ authGuard, roleGuard ],
    data: { roles: [ UserRole.Owner, UserRole.Admin, UserRole.Cashier ] },
    loadChildren: () => import('./modules/pos/pos.module').then((m) => m.PosModule),
  },
  {
    path: 'clicker',
    canActivate: [ authGuard, roleGuard ],
    data: { roles: [ UserRole.Owner, UserRole.Admin, UserRole.EventAdmin, UserRole.Cashier, UserRole.Volunteer ] },
    loadChildren: () => import('./modules/clicker/clicker.module').then((m) => m.ClickerModule),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
